import { NavLink } from 'react-router-dom';
import './navBar.css'
import { useAuth } from '../../../context/AuthContext';
import { useEffect, useState } from 'react';
import Loading from '../../Loading';




export default function NavBar() {
  const [ loading, setLoading ] = useState();
  const [ messages, setMessages ] = useState();
 // const [ hasMsgs, setHasMsgs ]= useState(true);

  const time = new Date().getTime();
  const defined = (v) => v !== undefined && v !== null && v !== "";

  const { logout, roles } = useAuth(); 
   console.log('NavBar roles:', roles); // Debugging line to check role
  const handleLogoutClick = () => {
    logout(); // Will clear token, user info, and redirect
  };
  const clickHome = () => {window.location.replace("/")}


  let hasMsgs = false;

  
      useEffect(() => {    

        async function fetchData() {
            setLoading(true)
            try {
                const dbResponse = await fetch('/api/system/banner/getmessages', {
                        method: 'GET'
                    }
                );
                const ans = await dbResponse.json();

                if (!dbResponse.ok || !ans?.success) {
                    setMessages({
                        success: false,
                        responseData: {
                            alert: { cdlis: [], fcwd: [] },
                            maintenance: { cdlis: [], fcwd: [] },
                        },
                    });
                    return;
                }

                setMessages(ans);
            } catch (error) {
                console.error("Error fetching banner:", error);
                setMessages({
                    success: false,
                    responseData: {
                        alert: { cdlis: [], fcwd: [] },
                        maintenance: { cdlis: [], fcwd: [] },
                    },
                });
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, []);

      if(loading){
            return(<>
            <Loading />
         </>)
        }

        if(!defined(messages) || !messages?.responseData){
            return (
                <nav className="nav-container">
                  <NavLink onClick={clickHome} className="nav-link" activeclassname="active-link">Home</NavLink>
                  <button className="nav-link" onClick={handleLogoutClick}>Logout</button>
                </nav>
            );
        }

    const toEpoch = (d) => {
        return new Date(d).getTime();
    }


  hasMsgs = messages?.responseData?.maintenance?.cdlis && messages?.responseData?.maintenance?.cdlis.length > 0;



    /*
    Check Announce list for cdlis messages and 
    if today is > msg start and < msg end
    then show Message tab
    */

  return (

    <nav className="nav-container">
      <NavLink onClick={clickHome} className="nav-link" activeclassname="active-link">Home</NavLink>  
       {roles && ( roles.includes("batch") ) &&   
        <>
          <NavLink to="/uploadbatch" className="nav-link" activeclassname="active-link">Upload Batch</NavLink>
          <NavLink to="/batchqueue" className="nav-link" activeclassname="active-link">Batch Queue</NavLink>
        </>
      }
      {roles && ( roles.includes("cdlisAdmin") ) &&   
        <>
          <NavLink to="/admin" className="nav-link" activeclassname="active-link">Admin</NavLink>
          <NavLink to="/banner" className="nav-link" activeclassname="active-link">Banner</NavLink>
        </>
      }
      {roles && ( roles.includes("cdlisAdmin") ) &&   
        <>
          <NavLink to="/reports" className="nav-link" activeclassname="active-link">Reports</NavLink>
        </>
      }
      <NavLink to="/queryfilters" className="nav-link" activeclassname="active-link">Set Query Default</NavLink>
      <NavLink to="/about" className="nav-link" activeclassname="active-link">About</NavLink>
      <button className="nav-link" onClick={handleLogoutClick}>Logout</button>
      
        {hasMsgs && ( hasMsgs === true ) && 
        <>
          <NavLink to="/messages" className="nav-link nav-warning-icon" activeclassname="active-link">&#9888;&#65039;</NavLink>
        </>}
        
        </nav>
  );
}
